<div class="min-h-screen bg-gray-50 py-8">
  <div class="max-w-6xl mx-auto px-4">
    <!-- Header -->
    <div class="text-center mb-8">
      <h1 class="text-3xl font-bold text-gray-900 mb-2">Panel de Cobranza</h1>
      <p class="text-gray-600">Gestiona todas las operaciones de cobranza y recuperación de cartera</p>
    </div>

    <!-- Lista de Opciones -->
    <div class="space-y-3">
      <ng-container *ngFor="let option of options">
        <ng-container *ngIf="hasPermission(option)">
          <a (click)="handleOptionClick(option)"
             class="block bg-white rounded-lg border border-gray-200 hover:border-blue-500 hover:shadow-md transition-all duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-400">
            <div class="flex items-center p-4">
              <div class="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center mr-4" [ngClass]="option.color">
                <i [class]="option.icon + ' text-2xl'"></i>
              </div>
              <div class="flex-1 min-w-0">
                <h3 class="text-lg font-semibold text-gray-900">{{ option.title }}</h3>
                <p class="text-sm text-gray-600">{{ option.description }}</p>
              </div>
              <div class="flex-shrink-0 ml-4">
                <i class="fas fa-chevron-right text-gray-400"></i>
              </div>
            </div>
          </a>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<!-- Modal: Buscar cliente para Distribución de Pagos -->
<div *ngIf="showDistriSearchModal"
     class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-10 backdrop-blur-sm p-4"
     (click)="closeDistriSearchModal()">
  <div class="bg-white rounded-lg shadow-xl w-full max-w-md" (click)="$event.stopPropagation()">
    <div class="flex items-center justify-between border-b border-gray-200 px-6 py-4">
      <h3 class="text-lg font-semibold text-gray-900">
        <i class="fas fa-chart-pie text-blue-600 mr-2"></i>
        Distribución de Pagos
      </h3>
      <button type="button" class="text-gray-400 hover:text-gray-600" (click)="closeDistriSearchModal()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="px-6 py-4 space-y-4">
      <p class="text-sm text-gray-600">Ingrese la cédula del cliente para consultar su distribución de pagos.</p>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Código</label>
        <select [(ngModel)]="distriSearchTypeIdentity"
                class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 py-2 px-3 border">
          <option value="V">V</option>
          <option value="E">E</option>
          <option value="J">J</option>
        </select>
      </div>

      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Número de Cédula</label>
        <input type="text"
               [(ngModel)]="distriSearchIdentity"
               (keyup.enter)="searchDistriByIdentity()"
               placeholder="Ingrese el número de cédula"
               [disabled]="distriSearchLoading"
               class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 py-2 px-3 border" />
      </div>

      <div *ngIf="distriSearchError" class="text-sm text-red-600">
        <i class="fas fa-exclamation-circle mr-1"></i>{{ distriSearchError }}
      </div>
    </div>

    <div class="flex justify-end gap-2 border-t border-gray-200 px-6 py-4">
      <button type="button"
              class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
              (click)="closeDistriSearchModal()"
              [disabled]="distriSearchLoading">
        Cancelar
      </button>
      <button type="button"
              class="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 disabled:opacity-50"
              (click)="searchDistriByIdentity()"
              [disabled]="distriSearchLoading || !distriSearchIdentity">
        <i class="fas fa-search mr-1" *ngIf="!distriSearchLoading"></i>
        <i class="fas fa-spinner fa-spin mr-1" *ngIf="distriSearchLoading"></i>
        {{ distriSearchLoading ? 'Buscando...' : 'Consultar' }}
      </button>
    </div>
  </div>
</div>
